<ion-card>
    <ion-card-content>
        <ion-label>{{title}}</ion-label>
        <ion-fab vertical="center" horizontal="end" >
            <ion-row class="ion-no-margin ion-no-padding">
                <ion-fab-button (click)="scanItem()" size="small" color="light">
                    <ion-icon name="barcode"></ion-icon>
                </ion-fab-button>  
              <ion-fab-button (click)="productSelect()" size="small" color="light">
                 <ion-icon [name]="icon"></ion-icon>
              </ion-fab-button>
            </ion-row>
        </ion-fab>
    </ion-card-content>
    <ion-list *ngIf="document.detailLines.length > 0">
        <ion-item-sliding *ngFor="let item of detailLines">
            <ion-item (click)="editItemQty(item)">
                <ion-label class="ion-text-wrap">
                    <p>{{item.qty}} - {{item.comment}}</p>
                    <p *ngIf="item.supplierRef !== null && item.supplierRef != '' "><b>Supplier Ref :</b> {{item.supplierRef}}</p>
                    <p *ngIf="item.binLocations !== null && item.binLocations != '' " ><b>Bin Locations :</b> {{item.binLocations}}</p>
                    <!-- Show either physical or on order stock level-->
                    <p *ngIf="item.physicalStock !== null && item.physicalStock > 0 " ><b>Stock :</b> {{item.physicalStock}}</p>
                    <p *ngIf="item.onOrderStock !== null && item.physicalStock <= 0 " ><b>On Order :</b> {{item.onOrderStock}}</p>
                </ion-label>

            </ion-item>
            <ion-item-options side="start" *ngIf="detailLines.length > 0">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button color="danger" (click)="deleteLine(item)">
                        <ion-icon name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>
        </ion-item-sliding>
    </ion-list>
</ion-card>
